import gsap from 'gsap';
import Splide from '@splidejs/splide';
import Tween from '../utils/tween';

const u_loop = (n: number, count: number) => {
    return ((n % count) + count) % count;      
  }
  
  const u_indexToPos = (index: number, currentIndex: number, count: number) => {
    currentIndex = u_loop(currentIndex, count);
    const offset = count * 0.5 - index;
    const oCurrent = u_loop(currentIndex + offset, count);
    const oIndex = u_loop(index + offset, count);
    return oIndex - oCurrent;
  }
  
  class HomeMvCarousel {
  
    private $el: HTMLElement;
    private $items: HTMLElement[] | null;
  
    private _index: number = 0;
    private _itemWidth: number = 0;  
    private _prevChangeTime: number = Date.now();
  
    private _tween: Tween | null = null;
    private _boundUpdate: () => void;  
  
    private options = {
      duration: 5000,  
      speed: 800,
      easing: 'easeInOutExpo',
    }
  
    constructor($el: HTMLElement) {
      this.$el = $el;
      this.$items= Array.from(this.$el?.querySelectorAll('.js_home_mv_carousel_item') || []) as HTMLElement[];    
      this._boundUpdate = this._update.bind(this);
      this._tween = new Tween(0);
      if(this.$items.length === 0) return;    
      this._init();    
    }
  
    private _init() {
  
      this._resize();
      this._setupEvents();    
  
      this._update();            
      
      this.to((this.$items?.length || 1), 10);

      requestAnimationFrame(() => {
        this._resize();        
        this.$el.style.visibility = 'visible';
      });         
    }
  
    private _update() {
      window.requestAnimationFrame(this._boundUpdate);    
      const now = Date.now();
      const isChange = (now - this._prevChangeTime) > this.options.duration;    
      if(isChange) {
        this.to(this._index + 1);
        this._prevChangeTime = now;
      }
      
      const currentIndex = this._tween?.value || 1;
      const length = this.$items?.length || 1;    
      this.$items?.forEach(($_item, index) => {                  
        const pos = u_indexToPos(index, currentIndex, length);      
        $_item.style.transform = `translateX(${pos * this._itemWidth}px)`;
      })  
    }
  
    private _resize() {
      this._itemWidth = (this.$el?.clientWidth || 1) * 1.2;    // オーバーラップさせるために1.2倍にしている
      this.$items?.forEach(($_item) => {
        $_item.style.width = `${this._itemWidth}px`;
      })
    }
  
    private _setupEvents() {
      window.addEventListener('resize', this._resize.bind(this));
    }
  
    to(targetIndex: number, duration?: number) {
      this._index = targetIndex;
  
      let d = duration || this.options.speed;
      if(duration === 0) {
        d = 0;
      }
  
      this._tween?.to({
        to: targetIndex,
        duration: d,
        easing: this.options.easing,
        onStart: () => {
          this.$items?.forEach(($_item, index) => {
            $_item.classList.remove('is-active');
          })
        },
        onComplete: () => {
          const currentIndex = u_loop(this._index, this.$items?.length || 1);
          const $currentItem = this.$items?.[currentIndex];
          if(!$currentItem) return;          
          $currentItem.classList.add('is-active');
        }
      });
    }
  }


const initHomeMvCarousel = () => {
    const $el = document.querySelector<HTMLElement>('#js_home_mv_carousel');
    if(!$el) return;
    const carousel = new HomeMvCarousel($el);    
  };
  
  const initHomeInterviewCarousel = () => {
    const $el = document.querySelector<HTMLElement>('#js_home_interview_carousel');
    if(!$el) return;
    const carousel = new Splide($el, {    
      autoWidth: true,
      autoHeight: true,
      arrows: false,    
      gap: '32px',    
      pagination: false,
    });
    carousel.mount();
  
    const changeProgress = () => {
      const end  = carousel.Components.Controller.getEnd() + 1;
      const rate = Math.min( ( carousel.index + 1 ) / end, 1 );
      gsap.to('#js_home_interview_progressBar', {
        scaleX: rate,
        duration: 1,
        ease: 'power2.inOut',
      });
    };
  
    changeProgress();
    carousel.on('mounted move', changeProgress);  
  };

export {
    initHomeMvCarousel,
    initHomeInterviewCarousel,
}